import {useAgencyInviteMutation, useAgencyInvitesQuery, useAgencyMembersQuery} from "@/api/agencyApi";
import CompanyLogoPlaceholder from "@/assets/light_gradient/company_logo_placeholder.svg";
import Loader from "@/components/Common/kpi/Loader";
import Modal from "@/components/Common/Modal";
import CompanyMembers from "@/components/MultiAccount/CompanyMembers";
import InviteMember from "@/components/MultiAccount/InviteMember";
import {useSelectedAgency} from "@/hooks/useUserHooks";
import {inviteStateAtom, isAgencyInviteModalOpenAtom} from "@/store/jotaiAtoms";
import {useAtom, useSetAtom} from "jotai";
import {RESET} from "jotai/utils";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const AgencyInviteModal: FC = () => {
  const {t} = useTranslation(["multi_account", "common"]);
  const closeModal = useSetAtom(isAgencyInviteModalOpenAtom);
  const agency = useSelectedAgency();
  const {
    data: agencyInvites,
    isPending: isPending1,
    refetch,
  } = useAgencyInvitesQuery({
    agencyId: agency?.id!,
  });
  const {data: agencyMembers, isPending: isPending2} = useAgencyMembersQuery({
    agencyId: agency?.id!,
  });
  const [invite, setInvite] = useAtom(inviteStateAtom);
  const {mutate} = useAgencyInviteMutation({
    agencyId: agency?.id!,
    email: invite.email,
    mutationOptions: {
      onSuccess: () => {
        setInvite(RESET);
        refetch();
      },
    },
  });

  return (
    <Modal
      onClose={() => closeModal(false)}
      modalTitle={t("multi_account:invite_modal_title")}
      className="min-h-[480px]"
      backgroundClassName="flex max-w-[600px]"
      customBottomRow={<></>}>
      <div className="flex flex-col gap-5 px-5">
        <InviteMember
          logo={agency?.picture320 ?? agency?.picture ?? CompanyLogoPlaceholder}
          name={agency?.name!}
          showPermissionSelector={false}
          fixPermission={
            <div className="border-primary-light-solid flex h-10 min-w-16 items-center justify-center rounded-md border text-xs">
              {t("common:Admin")}
            </div>
          }
          inviteMember={() => mutate()}
        />
        {isPending1 || isPending2 ? (
          <Loader />
        ) : (
          <CompanyMembers
            companyId={agency?.id!}
            companyMembers={agencyMembers ?? []}
            companyInvites={agencyInvites?.filter(invite => invite.status === "PENDING") ?? []}
            isAgency
            upgradePermission={() => {}}
          />
        )}
      </div>
    </Modal>
  );
};

export default AgencyInviteModal;
